import React, { createContext, useContext, useState, ReactNode } from "react";
import FullPageError from "../components/FullPageError/FullPageError";

interface ErrorContextType {
  error: string | null;
  setError: (message: string | null) => void;
  resetError: () => void;
}

const ErrorContext = createContext<ErrorContextType | undefined>(undefined);

export const ErrorProvider = ({ children }: { children: ReactNode }) => {
  const [error, setError] = useState<string | null>(null);

  const resetError = () => setError(null);

  return (
    <ErrorContext.Provider value={{ error, setError, resetError }}>
      {error ? <FullPageError /> : children}
    </ErrorContext.Provider>
  );
};

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error("useError must be used within an ErrorProvider");
  }
  return context;
};
